module.exports = __webpack_public_path__ + "media/components/assets/icons/arrow_left_light-d6444a11691a4aa03968e5b459d1af06.svg";